module.exports = __webpack_public_path__ + "static/media/smart_logo.156874b7.png";